import { createStyles, makeStyles } from '@material-ui/core';

export const FBPurchaseOrderStyles = makeStyles(() =>
  createStyles({
    receiveAllBtn: {
      margin: '10px 0 0',
      padding: '19px 59px',
    },
  }));
